import { getQueryParams, setCookie, getCookies } from "@crystal/core";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getRuntimeInfo } from "../integration/state-getters.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import { getSourceId, Scenario } from "./source-id-utils.js";
import { Touchpoint } from "./touchpoints.js";
import "./presets.js";
import "../ap2/config.js";
import "../ap2/state.js";
import "../external-auth/config.js";
import "@crystal/config";
import { getIAFParams } from "../integration/invite-a-friend.js";
function getExternalTouchpointParameters() {
  const storage = typeof sessionStorage !== "undefined" ? sessionStorage : {};
  const queryParams = getQueryParams();
  const storeSourceId = queryParams.sourceId || storage.sourceId;
  const storeId = queryParams.storeId || storage.storeId;
  const isStoreParamsValid = storeSourceId && storeId;
  if (isStoreParamsValid) {
    return {
      sourceId: storeSourceId,
      storeId
    };
  }
  const externalSourceId = queryParams.source;
  if (getRuntimeInfo().isAuthProvider && externalSourceId) {
    return {
      sourceId: externalSourceId,
      storeId
    };
  }
}
function hasExternalTouchpointParameters() {
  return !!getExternalTouchpointParameters();
}
const INVITATION_CODE_KEY = "invitationCode";
const saveInvitationCodeValue = () => {
  const queryParams = getQueryParams();
  const { invitationCode } = getIAFParams(queryParams);
  if (invitationCode) {
    setCookie(INVITATION_CODE_KEY, invitationCode);
  }
};
function getExternalInvitationCode() {
  const invitationCode = getCookies()[INVITATION_CODE_KEY];
  const inviteFriendRegistrationSourceId = getSourceId(Touchpoint.InviteAFriend, Scenario.Registration);
  return invitationCode ? {
    invitationCode,
    sourceId: inviteFriendRegistrationSourceId,
    createMember: false
  } : void 0;
}
const SOURCE_ID_KEY = "sourceId";
function getExternalSourceId() {
  const sourceId = getCookies()[SOURCE_ID_KEY];
  return sourceId ? { sourceId } : void 0;
}
export {
  getExternalInvitationCode,
  getExternalSourceId,
  getExternalTouchpointParameters,
  hasExternalTouchpointParameters,
  saveInvitationCodeValue
};
//# sourceMappingURL=external-parameters.js.map
